"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Section = _interopRequireDefault(require("./Section.style"));
var _misc = require("../../misc");
var _Icon = _interopRequireDefault(require("../../icon/Icon"));
var _title = require("../../title");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Section = function Section(_ref) {
  var children = _ref.children,
    name = _ref.name,
    index = _ref.index,
    onAdd = _ref.onAdd,
    onDuplicate = _ref.onDuplicate,
    onDelete = _ref.onDelete,
    labels = _ref.labels,
    className = _ref.className,
    disabled = _ref.disabled;
  var menuItems = [];
  if (onAdd && index) {
    menuItems.push({
      name: labels.PENSION_THRESHOLD_ADD_LABEL,
      icon: 'ion-plus',
      onClick: function onClick() {
        onAdd(index);
      }
    });
  }
  if (onDuplicate && index) {
    menuItems.push({
      name: labels.PENSION_THRESHOLD_DUPLICATE_LABEL,
      icon: 'ion-ios-copy',
      onClick: function onClick() {
        onDuplicate(index);
      }
    });
  }
  if (onDelete && index) {
    menuItems.push({
      name: labels.PENSION_THRESHOLD_DELETE_LABEL,
      icon: 'ion-trash-b',
      onClick: function onClick() {
        onDelete(index);
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_Section["default"], {
    className: "section section-wrapper ".concat(className)
  }, (name || onAdd || onDuplicate || onDelete) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "section-head"
  }, name && /*#__PURE__*/_react["default"].createElement(_title.BlockSubtitle, null, name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "section-body"
  }, !disabled && index && (onAdd || onDuplicate || onDelete) && /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
    className: "section-menu",
    menuItems: menuItems,
    position: "top-right",
    id: "testMenu"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-more-vertical"
  })), children));
};
Section.propTypes = {
  disabled: _propTypes["default"].bool,
  /** Text or html to be displayed inside the button */
  children: _propTypes["default"].node.isRequired,
  /** The name of the formula section. */
  name: _propTypes["default"].string,
  /** The index of the current section (required for add, duplicate and delete) */
  index: _propTypes["default"].number,
  /** Callback for when clicking on add in the menu in the listmenu. */
  onAdd: _propTypes["default"].func,
  /** Callback for when clicking on duplicate in the menu in the listmenu. */
  onDuplicate: _propTypes["default"].func,
  /** Callback for when clicking on delete in the menu in the listmenu. */
  onDelete: _propTypes["default"].func,
  /** The element class name */
  className: _propTypes["default"].string,
  /** CMS labels */
  labels: _propTypes["default"].shape({
    PENSION_THRESHOLD_ADD_LABEL: _propTypes["default"].string.isRequired,
    PENSION_THRESHOLD_DUPLICATE_LABEL: _propTypes["default"].string.isRequired,
    PENSION_THRESHOLD_DELETE_LABEL: _propTypes["default"].string.isRequired
  }).isRequired
};
Section.defaultProps = {
  disabled: false,
  name: '',
  index: undefined,
  onAdd: undefined,
  onDuplicate: undefined,
  onDelete: undefined,
  className: ''
};
var _default = exports["default"] = Section;